module.exports = __webpack_public_path__ + "static/media/thumbsup.b4796690.png";